import { Form } from "antd";
import styled from "styled-components";

export const StyledForm = styled(Form)`
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 100%;
`;
